import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#004EEB",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2.333",
      d: "M2.334 11.667S4.672 8.48 6.573 6.578A10.47 10.47 0 0 1 14 3.5c5.8 0 10.5 4.701 10.5 10.5S19.8 24.5 14 24.5c-4.787 0-8.826-3.203-10.09-7.583m-1.577-5.25v-7m0 7h7"
    }, null, -1)
  ])))
}
export default { render: render }